<template>
  <div id="rate">
    <v-snackbar v-model="showThanks">Thank you for your feedback!</v-snackbar>
    <v-toolbar flat>
      <v-spacer/>
      <v-btn color="success" v-if="!showFeedbackForm" @click="showFeedbackForm=!showFeedbackForm">Leave Feedback</v-btn>
      <v-btn color="warning" v-if="showFeedbackForm" @click="showFeedbackForm=!showFeedbackForm">Cancel</v-btn>
    </v-toolbar>
    <v-progress-circular v-if="loading" indeterminate :size="50" color="primary"></v-progress-circular>
    <v-dialog v-model="showFeedbackForm" max-width="600">
      <v-card class="pb-4">
        <v-card-title>
          <div v-html="labels.feedback_request_html">
          </div>
        </v-card-title>
        <v-card-text>
          <div class="star-icons">
            <template v-for="i in 5">
              <v-icon v-if="rating.overall < i" :key="i" large color="grey" v-on:click="rateMeal('overall', i)">
                star_border
              </v-icon>
              <v-icon v-if="rating.overall >= i" :key="i" large color="orange" v-on:click="rateMeal('overall', i)">
                star
              </v-icon>
            </template>
          </div>
        </v-card-text>
        <v-card-text v-if="rating.overall  && rating.overall<5">
          <div>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <h3>{{ labels.feedback_taste }}</h3>
                <div class="star-icons">
                  <template v-for="i in 5">
                    <v-icon v-if="rating.taste < i" :key="i" large color="grey" v-on:click="rateMeal('taste', i)">
                      star_border
                    </v-icon>
                    <v-icon v-if="rating.taste >= i" :key="i" large color="orange"
                            v-on:click="rateMeal('taste', i)">
                      star
                    </v-icon>
                  </template>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <h3>{{ labels.feedback_presentation }}</h3>
                <div class="star-icons">
                  <template v-for="i in 5">
                    <v-icon v-if="rating.presentation < i" :key="i" large color="grey"
                            v-on:click="rateMeal('presentation', i)">star_border
                    </v-icon>
                    <v-icon v-if="rating.presentation >= i" :key="i" large color="orange"
                            v-on:click="rateMeal('presentation', i)">star
                    </v-icon>
                  </template>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <h3>{{ labels.feedback_preparation }}</h3>
                <div class="star-icons">
                  <template v-for="i in 5">
                    <v-icon v-if="rating.preparation < i" :key="i" large color="grey"
                            v-on:click="rateMeal('preparation', i)">star_border
                    </v-icon>
                    <v-icon v-if="rating.preparation >= i" :key="i" large color="orange"
                            v-on:click="rateMeal('preparation', i)">star
                    </v-icon>
                  </template>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <h3>{{ labels.feedback_size }}</h3>
                <div class="star-icons">
                  <template v-for="i in 5">
                    <v-icon v-if="rating.portion < i" :key="i" large color="grey"
                            v-on:click="rateMeal('portion', i)">
                      star_border
                    </v-icon>
                    <v-icon v-if="rating.portion >= i" :key="i" large color="orange"
                            v-on:click="rateMeal('portion', i)">
                      star
                    </v-icon>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-text v-if="rating.overall">
          <div fluid>
            <v-layout row>
              <v-flex xs12>
                <v-textarea v-model="rating.comment"
                            name="comment"
                            :label="labels.feedback_comments"
                            outlined
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field v-model="rating.email"
                              name="email"
                              label="Email"
                              hint="leave your email so we can get in touch if needed"
                              persistent-hint
                              outlined
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="warning" v-if="showFeedbackForm" @click="showFeedbackForm=!showFeedbackForm">Cancel</v-btn>
          <v-btn class="mx-4"
                 rounded outlined @click="saveFeedback">{{ labels.btn_submit }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>

import Api from '@/services/Api';
import MealService from '@/services/MealService';
import {mapGetters} from 'vuex';
// import {Component, Vue, Watch} from 'vue-property-decorator';

export default {
  name: 'MealRate',
  data() {
    return {
      loading: false,
      showFeedbackForm: false,
      showThanks: false,
      rating: {
        overall: 0,
        taste: 0,
        presentation: 0,
        preparation: 0,
        portion: 0,
        comment: '',
        email: ''
      },
      labels: {}
    }
  },
  mounted() {
    this.initRating();
    Api().get('labels').then(response => {
      const {data} = response;
      this.labels = data;
    })
  },
  computed: {
    // ...mapGetters({
    //   'labels': 'getLabels'
    // })
    formIncomplete() {
      const rating = this.rating;
      return rating.overall < 5 && (rating.taste === 0 || rating.presentation === 0 || rating.preparation === 0 || rating.portion === 0)
    }
  },
  methods: {
    initRating: function () {
      this.rating = {
        overall: 0,
        taste: 0,
        presentation: 0,
        preparation: 0,
        portion: 0
      }
      const savedFeedback = localStorage.getItem(`meal_feedback_${this.meal.id}`);
      if (savedFeedback) {
        try {
          this.rating = {...this.rating, ...JSON.parse(savedFeedback)};
        } catch (e) {
          console.warn('failed to load saved feedback', savedFeedback);
        }
      }
      const email = localStorage.getItem('meal_feedback_email');
      if (email && !this.rating.email) {
        this.rating.email = email;
      }
    },

    rateMeal: function (prop, rating) {
      // this.$ga.event({
      //   eventCategory: this.$route.name,
      //   eventAction: 'update',
      //   eventLabel: `Rate ${prop}`,
      //   eventValue: rating
      // });
      this.rating[prop] = rating
    },
    saveFeedback: function () {
      if (this.formIncomplete) {
        alert('Please rate each aspect of the meal');
        return;
      }
      let review = this.rating;
      review.tod = this.meal.todname;
      review.date = this.meal.meal_assigned_date;
      review.title = this.meal.name;
      review.meal_id = this.meal.id;
      if (review.overall === 5) {
        review.portion = 5;
        review.preparation = 5;
        review.presentation = 5;
        review.taste = 5;
      }
      localStorage.setItem(`meal_feedback_${this.meal.id}`, JSON.stringify(review));
      if (review.email) {
        localStorage.setItem('meal_feedback_email', review.email);
      }
      Api().post('/feedback', review)
          .then(response => {
            // this.$ga.event({
            //   eventCategory: this.$route.name,
            //   eventAction: 'submit',
            //   eventLabel: 'Sent feedback',
            //   eventValue: review.overall
            // });
            // this.initRating();
            this.$emit('feedbackapproved');
            this.showFeedbackForm = false;
            this.showThanks = true;
          })
          .catch(e => {
            console.error('there was a problem saving your feedback.  please try again', e);
            alert('there was a problem saving your feedback.  please try again');
          });
    }
  },
  props: {
    meal: Object
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">

</style>
